<div class="relative-position">
  <div *ngIf="label" class="custom-form-label" [ngClass]="{ 'active': currentFocus }">{{label}}</div>
  <ng-container *ngIf="type!=='date'">
    <mat-form-field *ngIf="formGroup && formControlName" [formGroup]="formGroup"
                    [ngClass]="{ 'handyStyle': handyStyle }"
                    [subscriptSizing]="hideHelperText ? 'dynamic' : 'fixed'"
                    class="full-width">
      <input matInput class="full-width" [ngClass]="{'handyStyle': handyStyle }"
             [formControlName]="formControlName"
             [maxlength]="maxLen"
             [type]="type"
             #inputEl
             [placeholder]="placeholder"
             (focusin)="displaySuggestions(true)"
             autocomplete="false"
             [min]="min"
             [max]="max"
             [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of filteredSuggestions; let i = index" [value]="option"
                    (onSelectionChange)="applySuggestion(i, option)">
          {{option}}
        </mat-option>
      </mat-autocomplete>
      <mat-icon matPrefix *ngIf="leadingIcon" (click)="onLeadingIconClick.emit()">{{leadingIcon}}</mat-icon>
      <mat-error
        *ngIf="formGroup.controls[formControlName] && !formGroup.controls[formControlName].valid  && !hideHelperText"
        class="no-padding error-font">
        <span>{{getErrorText()}}</span>
      </mat-error>
    </mat-form-field>
  </ng-container>
  <!-- Seperate Datepicker input needed since having a conditional datePicker-Attribute does not work right now -->
  <ng-container *ngIf="type==='date'">
    <mat-form-field *ngIf="formGroup && formControlName" [formGroup]="formGroup"
                    [ngClass]="{ 'handyStyle': handyStyle }"
                    class="full-width" [subscriptSizing]="hideHelperText ? 'dynamic' : 'fixed'">
      <input matInput class="full-width" [ngClass]="{'handyStyle': handyStyle }"
             [formControlName]="formControlName"
             [maxlength]="maxLen"
             [type]="type"
             #inputEl
             autocomplete="false"
             [placeholder]="placeholder"
             [min]="min"
             [max]="max"
             [matDatepicker]="dp"/>
      <span class="clear-date" *ngIf="!formGroup.controls[formControlName].disabled">
  <mat-icon matDatepickerToggleIcon (click)="clearDate($event)" >clear</mat-icon>
</span>
      <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
      <mat-datepicker #dp
                      [startView]="formGroup.controls[formControlName] && formGroup.controls[formControlName].value ? 'month' : 'multi-year'"
                      [touchUi]="deviceSevice.isHandset()"></mat-datepicker>
      <mat-icon matPrefix *ngIf="leadingIcon">{{leadingIcon}}</mat-icon>
      <mat-error
        *ngIf="formGroup.controls[formControlName] && !formGroup.controls[formControlName].valid  && !hideHelperText"
        class="no-padding error-font">
        <span>{{getErrorText()}}</span>
      </mat-error>
    </mat-form-field>
  </ng-container>
</div>
